import { BP42Action } from '@r1-frontend/bp42/constants/actions';

import { IAction } from '@r1-frontend/shared/types/Redux';

const flushSubmitResult = (): IAction<BP42Action.FlushSubmitResult, null> => ({
    type: BP42Action.FlushSubmitResult,
    payload: null,
});

export default flushSubmitResult;
